import React, { useEffect, useRef, useState } from "react";
import AdminSideBar from "./AdminSideBar";
import { AdminNavigation } from "../../Admin/AdminNavigation";
import UseOutsideClick from "../../Admin/UseOutsideClick";
import close from "../../../images/Sidebar/close.svg";
import { NavLink } from "react-router-dom";
import { MdOutlineCorporateFare } from "react-icons/md";
import { RiContactsBookUploadFill, RiMentalHealthFill } from "react-icons/ri";
import { HiUserGroup } from "react-icons/hi";
import { MdManageAccounts } from "react-icons/md";
import { GiHypodermicTest,GiHealthNormal } from "react-icons/gi";
import userimg from "../../../images/Sidebar/adminuser.png";
import { TbBuildingEstate } from "react-icons/tb";


const AdminLayout = (props) => {
  const [sidemenu, setsidemenu] = useState(false);
  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (sidemenu) {
      setsidemenu(false);
    }
  });
  
    const [collapsed, setCollapsed] = useState(() => {
      const saved = localStorage.getItem("sidebar-collapsed");
      return saved ? JSON.parse(saved) : false;
    });
  
    //  Persist whenever collapsed changes
    useEffect(() => {
      localStorage.setItem("sidebar-collapsed", JSON.stringify(collapsed));
    }, [collapsed]);
  useEffect(() => {
    window.scrollTo({top : 0 , behavior : 'smooth'});
  },[])
  return (
    <>
      <div className="relative">
        <div className="sticky top-0 z-30 shadow-sm">
          <AdminNavigation setsidemenu={setsidemenu} />
        </div>
        <div className="xl:flex">
          <div className="fixed bottom-0 z-10 top-[58px] min-h-full overflow-y-auto overflow-x-visible scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100 bg-white" style={{ isolation: 'isolate' }}>
            <AdminSideBar  collapsed={collapsed} setCollapsed={setCollapsed}/>
          </div>

          {/* mobile side bar */}
          <div
            className={`${
              sidemenu &&
              `${"backcolor absolute z-[1002] top-0 bottom-0 right-0 left-0"}`
            } xl:hidden`}
          >
            <div
              className={`${
                sidemenu
                  ? "translate-x-0 h-full max-w-[335px] fixed bottom-0 px-[16px] pt-[25px] pb-[15px]"
                  : "-translate-x-full "
              } transform  ease-in-out transition duration-500  bg-[#FFFFFF] flex flex-col justify-between xl:hidden`}
              ref={ref}
            >
              {sidemenu && (
                <div className="min-w-[250px] flex-col justify-between flex">
                  <div>
                    <img
                      src={close}
                      className=" ml-auto"
                      onClick={() => setsidemenu(false)}
                      alt="new"
                    ></img>
                  </div>
                  <div>
                    <ul className="px-3 py-5 flex flex-col gap-2 w-[273px]">
                      <li>
                        <NavLink
                          to="/admin/admin_user/corporate"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <MdOutlineCorporateFare />
                          Corporate
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/hr"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <span className="text-xl">
                            <MdManageAccounts />
                          </span>
                          Admin
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/uploadeemployee"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <RiContactsBookUploadFill />
                          Create Member
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/employee"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <HiUserGroup />
                          Member List
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/export"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xlink="http://www.w3.org/1999/xlink"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            viewBox="0 0 24 24"
                            space="preserve"
                          >
                            <g>
                              <switch>
                                <g>
                                  <path
                                    d="M8.7 7.7 11 5.4V15c0 .6.4 1 1 1s1-.4 1-1V5.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1 0-.2.1-.3.2l-4 4c-.4.4-.4 1 0 1.4s1 .4 1.4 0zM21 14c-.6 0-1 .4-1 1v4c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-4c0-.6-.4-1-1-1z"
                                    fill="#000000"
                                    opacity="1"
                                    data-original="#000000"
                                  ></path>
                                </g>
                              </switch>
                            </g>
                          </svg>
                          Export
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/family_member"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <HiUserGroup />
                          Family Member
                        </NavLink>
                      </li>
                      {/* <li>
                        <NavLink
                          to="/admin/admin_user/doctor"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                         <GiHealthNormal />
                          Doctor
                        </NavLink>
                      </li> */}
                      <li>
                        <NavLink
                          to="/admin/admin_user/healthtips"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <RiMentalHealthFill />
                          Health Tips
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/labtest"
                          className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <GiHypodermicTest />
                          Book A Lab Test
                        </NavLink>
                      </li>
                      {/* <li>
              <NavLink
                to="/admin/admin_user/panel"
                className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
              >
                <img src={userimg} alt="wellness" className="w-[20px]" />
                Vibhuti
              </NavLink>
            </li>   */}
                      {/* <li>
              <NavLink
                to="/admin/admin_user/panel"
                className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
              >
                <img src={userimg} alt="wellness" className="w-[20px]" />
                Vibhuti Upload
              </NavLink>
            </li>   */}
                      <li>
                        <NavLink
                          to="/admin/admin_user/master"
                          className="flex items-center gap-3 px-3 font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <span className="text-xl">
                            <TbBuildingEstate />
                          </span>
                          Onevasco
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/admin_user/vfs_uk"
                          className="flex items-center gap-3 px-3 font-Roboto text-lg text-[#1A1A1A] py-3"
                        >
                          <span className="text-xl">
                            <TbBuildingEstate />
                          </span>
                          VFS UK LP
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* <div className="w-full  md:pl-[40px] xl:pl-[250px] min-h-[91.5vh] md:pr-[16px] bg-[#FFFCE1]">
            {props.children}
          </div> */}
          <div
            className={`transition-all duration-300 ${
              collapsed ? "pl-[80px]" : "pl-[240px]"
            } w-full bg-[#FFFCE1]`}
          >
            {props.children}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
